const DEFAULT_STATE: IContactInformationModel = {
	contactBrandTitle: 'Brand Contact',
	brokerBrandTitle: 'Broker',
	requestSampleTitle: 'Request A Sample',
	brandBusinessContact: 'Schedule A Call'
};
interface IContactInformationModel {
	contactBrandTitle: string;
	brokerBrandTitle: string;
	requestSampleTitle: string;
	brandBusinessContact: string;
}
export const contactInformationModel = {
	...DEFAULT_STATE
};
